import { Injectable } from '@angular/core';
import { UserInfo } from '@core/interfaces/entities/user-info.interface';
import { Mapper } from './mapper';
import { UserInfoDto } from '@core/dtos/user-info.dto';
import { StatusId } from '@shared/types/statusId.type';
import { ProfileMapper } from './profile.mapper';

@Injectable({ providedIn: 'root' })
export class UserInfoMapper extends Mapper<UserInfo, UserInfoDto> {
  constructor(private profileMapper: ProfileMapper) {
    super();
  }

  mapFrom(data: UserInfo): UserInfoDto {
    return {
      administrator: {
        id: data.id,
        fullname: data.fullname,
        email: data.email,
        status: data.administrator_status.id === StatusId.ACTIVE,
        uid: data.uid,
        profileId: data.profile?.id,
        profileName: data.profile?.name,
        companyId: data.company?.id,
        companyName: data.company?.name,
      },
      profile: this.profileMapper.mapFrom(data.profile),
    };
  }
}
